/**
 * Log de acompanhamento do vínculo de voz (lab).
 *
 * Hoje NÃO gravamos embedding/padrão acústico do áudio — só a chave de pessoa
 * (voiceProfileKey) e o evento de vínculo manual. Diarização real fica no backlog.
 *
 * Console: filtre por `[SmartMinutes][voz]`
 * Storage: localStorage `ata_inteligente_voice_profile_log`
 */

const STORAGE_KEY = "ata_inteligente_voice_profile_log";
const MAX_EVENTS = 200;

function safeParse(raw) {
  try {
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
}

export function listVoiceProfileLog() {
  if (typeof window === "undefined" || !window.localStorage) return [];
  return safeParse(localStorage.getItem(STORAGE_KEY));
}

function persist(events) {
  if (typeof window === "undefined" || !window.localStorage) return;
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(events.slice(-MAX_EVENTS))
  );
}

/**
 * Snapshot do que existe hoje: chave de vínculo, sem amostra acústica.
 */
export function buildVoiceLinkSnapshot({
  ataId,
  meetingId,
  speaker,
  person,
  personId,
  action
}) {
  const key = (person && person.id) || personId || null;
  return {
    at: new Date().toISOString(),
    action: action || (key ? "link" : "unlink"),
    voiceCapture: "not_implemented",
    voiceCaptureNote:
      "Lab: apenas voiceProfileKey (id da pessoa). Embedding/diarização ainda não registrados.",
    ataId: ataId || null,
    meetingId: meetingId || null,
    speakerId: speaker && speaker.id,
    detectedName: speaker && (speaker.detectedName || speaker.label),
    personId: key,
    personName: (person && person.name) || (speaker && speaker.personName) || null,
    personRole: (person && person.role) || (speaker && speaker.personRole) || null,
    voiceProfileKey: key,
    sampleStartSec: speaker && speaker.sampleStartSec,
    sampleEndSec: speaker && speaker.sampleEndSec,
    sampleEstimated: speaker ? speaker.sampleEstimated !== false : true
  };
}

export function logVoiceLinkEvent(payload) {
  const event = buildVoiceLinkSnapshot(payload || {});
  const events = listVoiceProfileLog();
  events.push(event);
  persist(events);

  /* eslint-disable no-console, no-underscore-dangle */
  if (typeof console !== "undefined" && console.info) {
    console.info(
      "[SmartMinutes][voz]",
      event.action === "unlink" ? "vínculo removido" : "vínculo registrado",
      {
        voiceCapture: event.voiceCapture,
        voiceProfileKey: event.voiceProfileKey,
        personName: event.personName,
        detectedName: event.detectedName,
        ataId: event.ataId,
        note: event.voiceCaptureNote
      }
    );
    console.info(
      "[SmartMinutes][voz] histórico (últimos eventos):",
      listVoiceProfileLog().slice(-8)
    );
  }

  if (typeof window !== "undefined") {
    window.__ATA_VOICE_PROFILE_LOG__ = listVoiceProfileLog;
    window.dispatchEvent(
      new CustomEvent("ata-voice-profile-log", { detail: event })
    );
  }
  /* eslint-enable no-console, no-underscore-dangle */

  return event;
}

/** Resumo por voiceProfileKey para inspeção rápida no console. */
export function summarizeVoiceProfiles() {
  const byKey = {};
  listVoiceProfileLog().forEach(ev => {
    const key = ev.voiceProfileKey || "_unlinked";
    if (!byKey[key]) {
      byKey[key] = {
        voiceProfileKey: ev.voiceProfileKey,
        personName: ev.personName,
        linkCount: 0,
        voiceCapture: ev.voiceCapture,
        lastAt: null
      };
    }
    if (ev.action === "link") byKey[key].linkCount += 1;
    byKey[key].personName = ev.personName || byKey[key].personName;
    byKey[key].lastAt = ev.at;
  });
  return Object.values(byKey);
}
